import React, { useEffect, useState, useRef, Fragment } from "react"
import PropTypes from "prop-types"

const loadStates = {
  UNMOUNTED: "UNMOUNTED",
  LOADING: "LOADING",
  FAILED: "FAILED",
  READY: "READY",
  ACTIVATED: "ACTIVATED",
}

const Player = ({ frames, frameWidth, frameHeight }) => {
  const [loadCount, setLoadCount] = useState(0)
  const [loadState, setLoadState] = useState(loadStates.UNMOUNTED)
  const [currentFrameIndex, setCurrentFrameIndex] = useState(null)
  const wrapperRef = useRef(null)

  useEffect(() => {
    setLoadState(loadStates.LOADING)
    setLoadCount(0)
  }, [frames])

  function handleMouseMove(e) {
    if (
      wrapperRef &&
      wrapperRef.current &&
      (loadState === loadStates.READY || loadState === loadStates.ACTIVATED)
    ) {
      const rect = wrapperRef.current.getBoundingClientRect()
      let x = 0
      if (e.type == "touchmove") {
        var touch = e.touches[0] || e.changedTouches[0]
        x = touch.pageX
      } else if (e.type == "mousemove") {
        x = e.pageX
      }
      let index = Math.floor(((x - rect.left) / rect.width) * frames.length)
      index = index < 0 ? 0 : index >= frames.length ? frames.length - 1 : index
      setCurrentFrameIndex(index)
      setLoadState(loadStates.ACTIVATED)
    }
  }

  function handleError() {
    setLoadState(loadStates.FAILED)
  }

  function handleLoad() {
    let newLoadCount = loadCount + 1
    console.log("handle load", newLoadCount)
    setLoadCount(newLoadCount)
    if (newLoadCount === frames.length) {
      setCurrentFrameIndex(0)
      setLoadState(loadStates.READY)
    }
  }

  if (loadState === loadStates.UNMOUNTED) {
    return null
  }

  if (loadState === loadStates.FAILED) {
    return (
      <div style={{ textAlign: "center", userSelect: "none" }}>
        Failed to load
      </div>
    )
  }

  return (
    <div style={{ textAlign: "center", userSelect: "none" }}>
      <div style={{ marginBottom: "20px" }}>
        {loadState === loadStates.LOADING && (
          <div>
            Loading {loadCount} of {frames.length} images...
          </div>
        )}

        {loadState === loadStates.READY && (
          <div>Drag your mouse over the horse 👇</div>
        )}
      </div>

      <div
        ref={wrapperRef}
        onTouchMove={handleMouseMove}
        onMouseMove={handleMouseMove}
        style={{
          position: "relative",
          margin: "auto",
          maxWidth: frameWidth + "px",
          maxHeight: frameHeight + "px",
        }}
      >
        {frames.map((src, index) => (
          <img
            onLoad={handleLoad}
            onError={handleError}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              visibility: index === currentFrameIndex ? "visible" : "hidden",
            }}
            src={src}
            key={src}
          />
        ))}
      </div>
    </div>
  )
}

Player.propTypes = {
  frames: PropTypes.arrayOf(PropTypes.string).isRequired,
  frameWidth: PropTypes.number.isRequired,
  frameHeight: PropTypes.number.isRequired,
}

export default Player
